module.exports = __webpack_public_path__ + "static/media/banner-foooter.dfe598a6.webp";